import React, { useState, useEffect } from 'react';
import ImageSlider from './ImageSlider';
import InfiniteScroll from 'react-infinite-scroll-component';

const Photos = () => {
  const baseURL = process.env.PUBLIC_URL + '/assets/Home/';

  const [images, setImages] = useState([
    '1.JPG',
    '2.JPG',
    // '3.jpg',
    '5.JPG',
    '6.JPG',
    '7.jpeg',
    '8.jpeg',
    '9.jpeg',
    // Add more image filenames as needed
  ]);

  const [hasMore, setHasMore] = useState(true);

  const fetchMoreImages = () => {
    // Simulate fetching more images
    // You can replace this with actual data fetching logic
    setTimeout(() => {
      const newImages = [
        '1.jpg',
        '2.jpg',
        // '3.jpg',
        '5.jpg',
        '6.jpg',
        '7.jpeg',
        '8.jpeg',
        '9.jpeg',
        // 'image5.jpg',
        // 'image6.jpg',
        // Add more new image filenames as needed
      ];

      setImages(prevImages => [...prevImages, ...newImages]);
      setHasMore(true); // Set to false if there are no more images to load
    }, 1000);
  };

  const getImageURL = (filename) => baseURL + filename;

  const imageUrls = images.map(getImageURL);

  return (
    <div>
      <InfiniteScroll
        dataLength={images.length}
        next={fetchMoreImages}
        hasMore={hasMore}
        
      >
        <ImageSlider images={imageUrls} />
      </InfiniteScroll>
    </div>
  );
};

export default Photos;
